<template>
  <div>
    <div class="search">
      <el-input placeholder="请输入内容" v-model="input" class="input-with-select">
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'search',
    data() {
      return {
        input: ''
      }
    },
    methods: {
      search() {
        this.$emit('getRoute', this.input);
      }
    }
  }
</script>

<style scoped>
  .search {
    width: 500px;
    margin: 200px auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/Search.vue